<template>
  <div class="login-container d-flex align-center justify-center">
    <!-- Background Watermarks -->
    <img src="@/assets/logosimbolo.png" class="background-watermark watermark-left" />
    <img src="@/assets/logosimbolo.png" class="background-watermark watermark-right" />

    <!-- Main Glass Wrapper -->
    <div class="glass-wrapper">
      <div class="login-grid fill-height align-center">
        
        <!-- Left Side: Login Form -->
        <div class="login-panel d-flex justify-center pa-5 relative-col">
          <v-card flat class="login-card un-elevated" width="100%" max-width="380">
            <v-card-text class="pa-6">
              <!-- Brand Logo -->
              <div class="text-center mb-6">
                <img src="@/assets/logotipologin.png" alt="Logo" style="max-height: 75px; width: auto;" />
              </div>
              
              <!-- Form -->
              <v-form @submit.prevent="login">
                
                <!-- Usuário -->
                <div class="input-group mb-4">
                  <label class="input-label">Usuário</label>
                  <v-text-field
                    v-model="userData.user_login"
                    placeholder="Usuário"
                    solo
                    flat
                    dense
                    height="44"
                    hide-details="auto"
                    class="custom-input"
                    @keypress.enter="$refs.pwd.focus()"
                  ></v-text-field>
                </div>

                <!-- Senha -->
                <div class="input-group mb-2">
                  <label class="input-label">Senha</label>
                  <v-text-field
                    v-model="userData.user_password"
                    :type="show ? 'text' : 'password'"
                    placeholder="Senha"
                    solo
                    flat
                    dense
                    height="44"
                    hide-details="auto"
                    class="custom-input"
                    ref="pwd"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                    @keypress.enter="login"
                  ></v-text-field>
                </div>

                <!-- Sign In Button -->
                 <v-btn
                   block
                   height="48"
                   color="#FF6A2A"
                   class="login-btn white--text text-capitalize mb-4"
                   elevation="0"
                   :loading="loader"
                   @click="login"
                   :disabled="!userData.user_login || !userData.user_password"
                 >
                   Entrar
                 </v-btn>

                 <!-- Forgot Password Link -->
                 <div class="text-center mb-6">
                   <a href="#" @click.prevent="forgotPasswordModal = true" class="forgot-link">Esqueci minha senha</a>
                 </div>

                 <!-- Footer (Removed Contact) -->
                 <div class="text-center mt-6">
                   <div class="divider-text mb-2">SIGFROTA</div>
                 </div>
              </v-form>
            </v-card-text>
          </v-card>
        </div>

        <!-- Right Side: Illustration -->
        <div class="illustration-panel d-none d-md-flex justify-center align-center full-height-col">
          <div class="illustration-container">
             <img src="@/assets/login_illustration_pump.png" alt="Login Illustration" class="illustration-img" />
          </div>
        </div>

      </div>
    </div>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      multi-line
      top
      right
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snack.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Forgot Password Dialog -->
    <v-dialog v-model="forgotPasswordModal" max-width="400" persistent>
      <v-card class="pa-4 rounded-xl">
        <v-card-title class="text-h6 font-weight-bold grey--text text--darken-3 pb-2">
          Recuperar Senha
        </v-card-title>
        <v-card-text>
          <p class="text-body-2 grey--text text--darken-1 mb-4">
            Informe seu e-mail cadastrado. Enviaremos uma nova senha de acesso para você.
          </p>
          <div class="input-group">
            <label class="input-label">E-mail</label>
            <v-text-field
              v-model="recoveryEmail"
              placeholder="seu@email.com"
              solo
              flat
              dense
              height="44"
              hide-details="auto"
              class="custom-input mb-4"
              @keypress.enter="recoverPassword"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-btn 
            text 
            class="text-capitalize grey--text text--darken-1 font-weight-bold" 
            @click="forgotPasswordModal = false"
            :disabled="recoveryLoader"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="#FF6A2A" 
            class="white--text text-capitalize px-6" 
            elevation="0"
            rounded
            :loading="recoveryLoader"
            @click="recoverPassword"
            :disabled="!recoveryEmail"
          >
            Enviar Senha
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false,
    loader: false,
    forgotPasswordModal: false,
    recoveryEmail: "",
    recoveryLoader: false,
    userData: {
      user_login: "",
      user_password: "",
    },
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    if (sessionStorage.getItem("token")) {
      this.$router.push("/dashboard");
    } else {
      // Ensure we stay on login if no token
    }
  },
  methods: {
    login() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.userData.user_login = this.userData.user_login.trim();
      this.userData.user_password = this.userData.user_password.trim();
      this.$http
        .post("/login", this.userData)
        .then((r) => {
          if (r.data.success) {
            sessionStorage.setItem("token", r.data.token);
            const dataUser = r.data.user[0];
            delete dataUser.user_password;
            if (r.data.user[0].table_key && r.data.user[0].table_id) {
              this.$http(
                `/${r.data.user[0].table_key}/${r.data.user[0].table_id}`
              ).then((res) => (dataUser.ref = res.data[0]));
            }
            this.$http(`/access-groups/${r.data.user[0].group_id}`)
              .then((r) =>
                this.$store.dispatch(
                  "userPermissions",
                  JSON.parse(r.data[0].group_permissions)
                )
              )
              .catch(() => this.$store.dispatch("userPermissions", []));
            this.snack.show = true;
            this.snack.message = r.data.success;
            this.snack.color = "success";

            this.$http.post("/supplies/repairvalues").then(() => {});
            setTimeout(() => {
              sessionStorage.setItem("userData", JSON.stringify(dataUser));
              this.$store.dispatch("userData", dataUser);
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
              window.location.reload(1);
            }, 2000);
          } else {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = r.data.error;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", this.loader);
          }
        })
        .catch(() => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message =
            "SEM CONEXÃO COM O SERVIDOR. ENTRE EM CONTATO COM O SUPORTE! ";
          this.snack.color = "warning";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    recoverPassword() {
      if (!this.recoveryEmail) return;
      
      this.recoveryLoader = true;
      this.$http.post("/password-reset", { email: this.recoveryEmail.trim() })
        .then((r) => {
          this.recoveryLoader = false;
          this.forgotPasswordModal = false;
          this.recoveryEmail = "";
          
          this.snack.show = true;
          this.snack.message = r.data.message || "E-mail enviado com sucesso!";
          this.snack.color = "success";
        })
        .catch((e) => {
          this.recoveryLoader = false;
          this.snack.show = true;
          this.snack.message = e.response && e.response.data && e.response.data.error 
            ? e.response.data.error 
            : "Erro ao solicitar recuperação. Verifique o e-mail ou tente novamente mais tarde.";
          this.snack.color = "error";
        });
    }
  },
};
</script>

<style scoped>
/* Design System Tokens
   Primary Orange: #FF6A2A
   Soft Peach Background: #FFE3D1
*/

.login-container {
  position: fixed;
  inset: 0;
  min-height: 100vh;
  width: 100vw;
  font-family: 'DM Sans', 'Inter', sans-serif;
  background-color: #FFDAC1;
  background: linear-gradient(135deg, #FFDAC1 0%, #FFE3D1 100%);
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative; /* Context for absolute watermarks */
  overflow: hidden; /* Crop watermarks */
}

.login-grid {
  width: 100%;
  min-height: 500px;
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
}

.login-panel,
.illustration-panel {
  min-width: 0;
}

/* Watermarks */
.background-watermark {
  position: absolute;
  width: 500px; /* Large size */
  height: auto;
  opacity: 0.35; /* More visible */
  filter: blur(6px);
  z-index: 1; /* Behind glass wrapper */
  pointer-events: none;
}

.watermark-left {
  top: -100px;
  left: -150px;
  transform: rotate(-15deg);
}

.watermark-right {
  bottom: -100px;
  right: -100px;
  transform: rotate(15deg);
}

/* Glass Wrapper */
.glass-wrapper {
  z-index: 2; /* Above watermarks */
  width: 100%;
  max-width: 1100px;
  min-height: 500px;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);
  overflow: hidden;
  position: relative;
}

/* Left Column */
.relative-col {
  z-index: 2;
}

.login-card {
  background-color: rgba(255, 255, 255, 0.85) !important;
  border-radius: 20px !important;
  box-shadow: 0 10px 40px rgba(0,0,0,0.05) !important;
  /* Ensure it doesn't touch edges */
}

/* Typography */
.brand-label {
  font-size: 13px;
  color: #FF6A2A;
  font-weight: 500;
}

.login-title {
  font-size: 32px;
  font-weight: 800;
  color: #1A1A1A;
  margin: 0;
  line-height: 1.2;
}

.input-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #4A4A4A;
  margin-bottom: 6px;
  margin-left: 2px;
}

/* Custom Input Styles */
.custom-input.v-input {
  font-size: 14px;
}

.custom-input >>> .v-input__slot {
  background-color: #FFFFFF !important;
  border: 1px solid #EAEAEA !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.04) !important;
  min-height: 44px !important;
  transition: all 0.3s ease;
}

.custom-input.v-input--is-focused >>> .v-input__slot {
  border-color: #FF6A2A !important;
  box-shadow: 0 0 0 3px rgba(255, 106, 42, 0.15) !important;
}

.custom-input >>> input {
  color: #333 !important;
}

.custom-input >>> input::placeholder {
  color: #BBB !important;
}

/* Links */
.forgot-link {
  font-size: 12px;
  color: #8D5C45; /* Brownish from image */
  text-decoration: none;
  font-weight: 600;
}

.forgot-link:hover {
  text-decoration: underline;
  color: #FF6A2A;
}

/* Button */
.login-btn {
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background-color: #FF6A2A !important;
  box-shadow: 0 4px 14px rgba(255, 106, 42, 0.2) !important;
}

/* Divider */
.divider-text {
  font-size: 11px;
  color: #7A7A7A;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Social Buttons */
.social-btn {
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
}

/* Register footer */
.text-signup {
  font-size: 12px;
  color: #555;
  font-weight: 500;
}

.link-signup {
  font-size: 12px;
  color: #FF6A2A; /* Or dark brown #4e342e */
  font-weight: 800;
  text-decoration: none;
}

/* Illustration Area */
.illustration-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

@keyframes floating {
  0% { transform: translateY(0px) scale(1.1) translateX(-20px); }
  50% { transform: translateY(-15px) scale(1.1) translateX(-20px); }
  100% { transform: translateY(0px) scale(1.1) translateX(-20px); }
}

.illustration-img {
  max-width: 120%; /* Allow slight overlap */
  max-height: 400px;
  object-fit: contain;
  filter: drop-shadow(0 20px 40px rgba(255, 106, 42, 0.2));
  animation: floating 5s ease-in-out infinite;
}

/* Responsive */
@media (max-width: 960px) {
  .glass-wrapper {
    max-width: 100%;
    border-radius: 0;
    min-height: 100vh;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .login-grid {
    grid-template-columns: 1fr;
    min-height: 100vh;
  }
  
  .login-card {
    background-color: #FFF !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.05) !important;
    border-radius: 20px !important;
  }
  
  .login-container {
    padding: 0;
    background: #FFF1E6;
  }
}
</style>
